/* global bocAmchart4, am4charts, am4core, chartLanguage */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} event object containing the all the data
 * @returns {void}
 */
bocAmchart4.postProcessValetTwoDimensions = function (event) {

    try {
        return bocAmchart4.doPostProcessValetTwoDimensions(event);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        throw (error);
    }
};

/**
 *  Produces and returns an array of data based on the valet
 *
 * @param {object} event object containing the all the data
 * @returns {void}
 */
bocAmchart4.doPostProcessValetTwoDimensions = function (event) {
    var data = event.target.data;

    var chart = event.target.component;

    // If the data is compressed, uncompress it
    data = bocAmchart4.decodeData(data, chart);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running doPostProcessValetTwoDimensions, input data:",
            data
        );
    }

    if (chart.bocSettings.args.hasOwnProperty("datacallback")) {
        if (typeof window[chart.bocSettings.args.datacallback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running data callback "
                    + chart.bocSettings.args.datacallback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.datacallback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.datacallback](chart, data);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find data callback function "
                + chart.bocSettings.args.datacallback);
        }
    }

    var dataProcessor = new bocAmchart4.DataProcessor(chart, data, 'date');
    var processedData = dataProcessor.getObservationsInTwoDimensions();

    chart.maskBullets = false;

    // Create new column series
    var xAxis = chart.xAxes.getIndex(0);
    var yAxis = chart.yAxes.getIndex(0);

    yAxis.renderer.inversed = true;

    var series = chart.series.push(new am4charts.ColumnSeries());
    series.xAxis = xAxis;
    series.yAxis = yAxis;
    series.dataFields.dateX = "date";
    series.dataFields.categoryY = "category";
    series.dataFields.value = "v";
    series.dataFields.openDateX = "date";
    series.dataItems.template.locations.dateX = 1;
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("black");
    series.tooltip.background.stroke = am4core.color("black");

    var bgColor = new am4core.InterfaceColorSet().getFor("background");

    var columnTemplate = series.columns.template;
    columnTemplate.strokeWidth = 1;
    columnTemplate.strokeOpacity = 0.2;
    columnTemplate.stroke = bgColor;
    let possibleSpace = chartLanguage === "fr" ? " " : "";
    columnTemplate.tooltipText = "{category}" + possibleSpace + ": {v.formatNumber(#.#)}";

    columnTemplate.width = am4core.percent(100);
    columnTemplate.height = am4core.percent(100);

    bocAmchart4.initChartVars(chart);
    bocAmchart4.vars[chart.bocSettings.id].mainColors = [];
    bocAmchart4.vars[chart.bocSettings.id].legendBuckets = [];

    bocAmchart4.getColorsFromShortcode(chart);
    bocAmchart4.getBucketsFromShortcode(chart);

    bocAmchart4.vars[chart.bocSettings.id].allColors = [];

    if (chart.bocSettings.args.hasOwnProperty("markercount") && Number(chart.bocSettings.args.markercount) > 1) {
        series.columns.template.column.adapter.add("fill", function (fill, target) {
            return bocAmchart4.calculateHeatmapColors(chart, fill, target);
        });
    } else {
        bocAmchart4.defaultHeatmapLegend(chart, series, columnTemplate);
    }

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (typeof window[chart.bocSettings.args.callback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.callback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.callback](chart, processedData);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find data callback function " + chart.bocSettings.args.callback);
        }
    }

    bocAmchart4.getChartTitlesFromGroup(data, chart);
    bocAmchart4.processTitles(chart, processedData);
    bocAmchart4.processNotes(chart, processedData);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "After doPostProcessValet, processedData:",
            processedData
        );
    }

    new bocAmchart4.InteractiveProcessor(chart, processedData);
    if (typeof chart.bocSettings.interactiveConfig !== 'undefined') {
        processedData = chart.data;
    }
    event.target.data = processedData;

    bocAmchart4.generatePrintCopy(chart);
};
